export default __webpack_public_path__ + "static/media/selfie-with-note.76876531.jpg";